import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linkedin-solid",
  "use": "linkedin-solid-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"#fff\" aria-label=\"LinkedIn\" role=\"img\" viewBox=\"0 0 512 512\" id=\"linkedin-solid\"><rect width=\"512\" height=\"512\" fill=\"#0077b5\" rx=\"15%\" /><circle cx=\"104\" cy=\"104\" r=\"48\" /><path stroke=\"#fff\" stroke-width=\"86\" d=\"M237 178v259M104 178v259\" /><path d=\"M279 293c0-26 18-53 48-53 31 0 43 24 43 59v138h86V289c0-80-42-116-99-116-45 0-67 25-78 42\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol